import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ClaimsService } from '../../core/services/claims.service';
import { CLAIMS_API_ACTIONS } from '../actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ClaimsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly claimService: ClaimsService,
  ) {}

  get$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CLAIMS_API_ACTIONS.get),
      switchMap(() => this.claimService.getClaims()),
      map((data) => CLAIMS_API_ACTIONS.success({ data })),
      catchError((error: HttpErrorResponse) => of(CLAIMS_API_ACTIONS.error({ error }))),
    );
  });
}
